module.exports = __webpack_public_path__ + "static/day03-c4373c27dbecb7d42f19a136b6da4e77.png";